import DataTable from "react-data-table-component";
import { consolidateRows } from "../../../services/dashboard/formatDataConsolidateTable";
import { dataFormatNumberDecimal } from "../../../data/dataFormatNumberDecimal";

// Eliminadas las interfaces DatasetItem y Props

const TableBarChart = ({ rows, consolidate = true }) => {

    const processedRows = consolidate ? consolidateRows(rows) : rows;

    const columns = [
        {
            name: "Color",
            cell: (row) => (
                <div style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "4px",
                    backgroundColor: row.backgroundColor,
                    border: `2px solid ${row.borderColor}`
                }} />
            ),
            width: "80px",
            center: true
        },
        {
            name: "Indicador",
            selector: (row) => row.label,
            sortable: true,
            grow: 2
        },
        {
            name: "Valor (%)",
            selector: (row) => row.data[0],
            sortable: true,
            cell: (row) => (
                <span style={{ fontWeight: 600 }}>
                    {dataFormatNumberDecimal(row.data[0])}%
                </span>
            ),
            right: true
        }
    ];

    // Validación: Si no hay datos
    if (!processedRows || processedRows.length === 0) {
        return (
            <div style={{
                padding: '40px',
                textAlign: 'center',
                color: '#666',
                border: '2px dashed #ddd',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9'
            }}>
                <p style={{ fontSize: '16px', fontWeight: 500 }}>
                    No hay datos de indicadores disponibles
                </p>
                <p style={{ fontSize: '14px', marginTop: '8px', opacity: 0.7 }}>
                    Por favor, verifica que existan reportes para este proyecto
                </p>
            </div>
        );
    }

    return (
        <DataTable
            columns={columns}
            data={processedRows}
            highlightOnHover
            striped
            dense
            responsive
            noDataComponent="No hay registros para mostrar"
            customStyles={{
                headRow: {
                    style: {
                        backgroundColor: '#f5f5f5',
                        fontWeight: 'bold',
                        fontSize: '14px'
                    }
                },
                rows: {
                    style: {
                        fontSize: '13px'
                    }
                }
            }}
        />
    );
};

export default TableBarChart;